import { motion } from 'framer-motion'
import ScrollReveal from '../components/shared/ScrollReveal'
import GradientText from '../components/shared/GradientText'
import GlowButton from '../components/shared/GlowButton'
import './DraftPages.css'

const Icons = {
  layers: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polygon points="12 2 2 7 12 12 22 7 12 2" />
      <polyline points="2 17 12 22 22 17" />
      <polyline points="2 12 12 17 22 12" />
    </svg>
  ),
  trending: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
      <polyline points="17 6 23 6 23 12" />
    </svg>
  ),
  users: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  globe: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  target: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="6" />
      <circle cx="12" cy="12" r="2" />
    </svg>
  ),
  heart: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </svg>
  ),
  lightbulb: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="9" y1="18" x2="15" y2="18" />
      <line x1="10" y1="22" x2="14" y2="22" />
      <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14" />
    </svg>
  ),
  shield: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  sun: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="5" />
      <line x1="12" y1="1" x2="12" y2="3" />
      <line x1="12" y1="21" x2="12" y2="23" />
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
      <line x1="1" y1="12" x2="3" y2="12" />
      <line x1="21" y1="12" x2="23" y2="12" />
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </svg>
  ),
  linkedin: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
      <rect x="2" y="9" width="4" height="12" />
      <circle cx="4" cy="4" r="2" />
    </svg>
  )
}

const teamMembers = [
  {
    name: 'Edoardo Kadiysky',
    role: 'CEO & CTO',
    bio: 'Full-stack developer with 15+ years building scalable enterprise systems. Led development of 110+ components and 170+ APIs for the AI4Solar platform.',
    expertise: ['System Architecture', 'ML Engineering', 'Product Strategy'],
    linkedin: '#'
  },
  {
    name: 'Slav Simons',
    role: 'Chief Operating Officer',
    bio: 'Operations expert with deep experience in solar energy sector. Responsible for go-to-market strategy and customer success.',
    expertise: ['Operations', 'Solar Industry', 'Business Development'],
    linkedin: '#'
  },
  {
    name: 'George Georgiev',
    role: 'Hardware Consultant',
    bio: 'Hardware integration specialist with expertise in industrial IoT and solar equipment. Architected the sensor network infrastructure.',
    expertise: ['Hardware Integration', 'IoT Systems', 'Modbus TCP'],
    linkedin: '#'
  }
]

const timeline = [
  { year: '2023', event: 'Company Founded', description: 'AI4Renewables established with mission to democratize solar O&M' },
  { year: '2023', event: 'Platform Development', description: 'Built core monitoring platform with 110+ components' },
  { year: '2024', event: 'ML Integration', description: 'Deployed 6 ML models for predictive maintenance' },
  { year: '2024', event: 'Technology Validation', description: 'Platform validated in production environment' },
  { year: '2025', event: 'Market Launch', description: 'Commercial launch across pan-European market' }
]

const values = [
  {
    icon: Icons.sun,
    title: 'Clean Energy First',
    description: 'Every feature we build serves one purpose: maximizing clean energy production worldwide.'
  },
  {
    icon: Icons.lightbulb,
    title: 'Innovation with Purpose',
    description: 'We combine cutting-edge AI with practical solutions that work in the real world.'
  },
  {
    icon: Icons.shield,
    title: 'Reliability Above All',
    description: 'Solar operators depend on us. We build systems that work 24/7, 365 days a year.'
  },
  {
    icon: Icons.heart,
    title: 'Customer Obsessed',
    description: 'We succeed only when our customers reduce downtime and increase production.'
  }
]

const stats = [
  { value: '€2-3B', label: 'Annual EU Solar Losses', description: 'Preventable downtime costs' },
  { value: '406 GW', label: 'EU Installed Capacity', description: 'As of 2025 (SolarPower Europe)' },
  { value: '35%', label: 'C&I Market Share', description: 'Growing at 11.5% CAGR' },
  { value: '$52B', label: 'O&M Market by 2034', description: 'From $17B in 2025' }
]

const problemStats = [
  { value: '40-60%', label: 'Industry False Positive Rate', highlight: false },
  { value: '<5%', label: 'AI4Solar False Positive Rate', highlight: true },
  { value: '72h', label: 'Industry Detection-to-Repair', highlight: false },
  { value: '24h', label: 'AI4Solar Detection-to-Repair', highlight: true }
]

export default function About() {
  return (
    <div className="draft-page about-page">
      {/* Hero */}
      <section className="draft-hero about-hero">
        <div className="container">
          <ScrollReveal>
            <span className="draft-badge">About AI4Renewables</span>
          </ScrollReveal>
          <ScrollReveal delay={0.1}>
            <h1 className="draft-title">
              Predictive Maintenance for{' '}
              <GradientText gradient="energy">Solar 4.0</GradientText>
            </h1>
          </ScrollReveal>
          <ScrollReveal delay={0.2}>
            <p className="draft-subtitle">
              We're building the intelligence layer for the solar industry.
              Land. Air. Space. AI. All working together to maximize clean energy production.
            </p>
          </ScrollReveal>
        </div>
      </section>

      {/* Mission */}
      <section className="about-section">
        <div className="container">
          <div className="mission-grid">
            <ScrollReveal className="mission-content">
              <h2>Our Mission</h2>
              <p className="mission-lead">
                The solar industry loses €2-3 billion annually to preventable downtime in Europe alone.
                Equipment fails, performance degrades, and operators struggle with a 40-60% false positive rate
                that makes alerts meaningless.
              </p>
              <p>
                We founded AI4Renewables to change this. By fusing ground sensors, drone thermal imagery,
                and satellite data through advanced AI, we've achieved what the industry thought impossible:
                less than 5% false positives, 30-180 day failure predictions, and detection-to-repair times
                cut from 72 hours to 24.
              </p>
              <p>
                Our mission is simple: make predictive maintenance affordable for every solar operator,
                from 2 MW installations to 100+ MW portfolios. Because every megawatt of clean energy matters.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={0.2} className="mission-visual">
              <div className="mission-stats-grid">
                {stats.map((stat, i) => (
                  <motion.div
                    key={i}
                    className="mission-stat"
                    whileHover={{ scale: 1.02 }}
                  >
                    <span className="ms-value">{stat.value}</span>
                    <span className="ms-label">{stat.label}</span>
                    <span className="ms-desc">{stat.description}</span>
                  </motion.div>
                ))}
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* Problem/Solution */}
      <section className="about-section about-dark">
        <div className="container">
          <ScrollReveal className="section-header">
            <h2>The AI4Solar Difference</h2>
            <p>Industry benchmarks vs. our technology</p>
          </ScrollReveal>

          <div className="comparison-grid">
            {problemStats.map((stat, i) => (
              <ScrollReveal key={i} delay={i * 0.1}>
                <motion.div
                  className={`comparison-card ${stat.highlight ? 'highlight' : ''}`}
                  whileHover={{ y: -5 }}
                >
                  <span className="cc-value">{stat.value}</span>
                  <span className="cc-label">{stat.label}</span>
                </motion.div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="about-section">
        <div className="container">
          <ScrollReveal className="section-header">
            <h2>Leadership Team</h2>
            <p>Building the future of solar operations</p>
          </ScrollReveal>

          <div className="team-grid">
            {teamMembers.map((member, i) => (
              <ScrollReveal key={i} delay={i * 0.1}>
                <motion.div className="team-card" whileHover={{ y: -5 }}>
                  <div className="team-avatar">
                    <span className="avatar-initials">
                      {member.name.split(' ').map(n => n[0]).join('')}
                    </span>
                  </div>
                  <h3 className="team-name">{member.name}</h3>
                  <span className="team-role">{member.role}</span>
                  <p className="team-bio">{member.bio}</p>
                  <div className="team-expertise">
                    {member.expertise.map((skill, j) => (
                      <span key={j} className="expertise-tag">{skill}</span>
                    ))}
                  </div>
                  <a href={member.linkedin} className="team-linkedin">
                    {Icons.linkedin}
                    <span>Connect</span>
                  </a>
                </motion.div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="about-section about-dark">
        <div className="container">
          <ScrollReveal className="section-header">
            <h2>Our Values</h2>
            <p>What drives us every day</p>
          </ScrollReveal>

          <div className="values-grid">
            {values.map((value, i) => (
              <ScrollReveal key={i} delay={i * 0.1}>
                <motion.div className="value-card" whileHover={{ y: -5 }}>
                  <span className="value-icon">{value.icon}</span>
                  <h3>{value.title}</h3>
                  <p>{value.description}</p>
                </motion.div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="about-section">
        <div className="container">
          <ScrollReveal className="section-header">
            <h2>Our Journey</h2>
            <p>From idea to industry-ready platform</p>
          </ScrollReveal>

          <div className="timeline">
            {timeline.map((item, i) => (
              <ScrollReveal key={i} delay={i * 0.1}>
                <motion.div
                  className="timeline-item"
                  whileHover={{ x: 10 }}
                >
                  <div className="timeline-marker">
                    <span className="timeline-year">{item.year}</span>
                  </div>
                  <div className="timeline-content">
                    <h3>{item.event}</h3>
                    <p>{item.description}</p>
                  </div>
                </motion.div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      {/* Market Context */}
      <section className="about-section about-dark">
        <div className="container">
          <ScrollReveal className="section-header">
            <h2>The Market Opportunity</h2>
            <p>Positioned in a growing €5B+ global solar monitoring market</p>
          </ScrollReveal>

          <ScrollReveal delay={0.1}>
            <div style={{
              background: 'rgba(255, 255, 255, 0.03)',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              borderRadius: 'var(--radius-xl)',
              padding: 'var(--space-2xl)',
              marginBottom: 'var(--space-2xl)'
            }}>
              <p style={{ color: 'var(--color-gray-300)', fontSize: '1rem', lineHeight: 1.8, marginBottom: 'var(--space-lg)' }}>
                The solar monitoring software market is valued at <strong style={{ color: 'var(--color-white)' }}>$5 billion in 2025</strong>,
                projected to reach <strong style={{ color: 'var(--color-white)' }}>$15 billion by 2033</strong> at a 15.2% CAGR.
                The Commercial & Industrial segment—our target market—accounts for <strong style={{ color: 'var(--color-white)' }}>45-50% of revenue</strong> and
                is growing at 11.5% CAGR driven by corporate sustainability mandates and rising electricity costs.
              </p>
              <p style={{ color: 'var(--color-gray-300)', fontSize: '1rem', lineHeight: 1.8, marginBottom: 'var(--space-lg)' }}>
                While basic monitoring providers like Solytic, Solar-Log, and SMA dominate with commodity pricing,
                only <strong style={{ color: 'var(--color-white)' }}>38% of solar assets</strong> are connected to AI-based diagnostic platforms.
                <strong style={{ color: 'var(--color-white)' }}> 61% of companies struggle</strong> to integrate predictive analytics due to fragmented sensor data and outdated software.
              </p>
              <p style={{ color: 'var(--color-gray-500)', fontSize: '0.875rem' }}>
                Sources: SolarPower Europe, Guidehouse Insights, Precedence Research, and industry reports
              </p>
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* Company Info */}
      <section className="about-section">
        <div className="container">
          <ScrollReveal className="section-header">
            <h2>Company</h2>
            <p>Building the future of solar operations from the European Union</p>
          </ScrollReveal>

          <ScrollReveal delay={0.1}>
            <div className="partners-grid">
              <motion.div className="partner-card" whileHover={{ scale: 1.02 }}>
                <span className="partner-name">European Union</span>
                <span className="partner-type">Headquarters</span>
              </motion.div>
              <motion.div className="partner-card" whileHover={{ scale: 1.02 }}>
                <span className="partner-name">10 Languages</span>
                <span className="partner-type">Pan-European Support</span>
              </motion.div>
              <motion.div className="partner-card" whileHover={{ scale: 1.02 }}>
                <span className="partner-name">GDPR Compliant</span>
                <span className="partner-type">Data Protection</span>
              </motion.div>
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* CTA */}
      <section className="draft-cta">
        <div className="container">
          <ScrollReveal className="draft-cta-content">
            <h2>Join our mission</h2>
            <p>
              Whether you're a solar operator looking to reduce downtime,
              or an investor interested in clean energy tech, we'd love to connect.
            </p>
            <div className="cta-buttons">
              <GlowButton href="/demo" variant="solar" size="large">
                Request Demo
              </GlowButton>
              <GlowButton href="/pricing" variant="outline" size="large">
                View Pricing
              </GlowButton>
            </div>
          </ScrollReveal>
        </div>
      </section>
    </div>
  )
}
